module.exports = __webpack_public_path__ + "static/media/menu.ca394ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/menu.svg
// module id = 1296
// module chunks = 0